import { render } from "./ControleCobrancasView.vue?vue&type=template&id=4680055a&scoped=true"
import script from "./ControleCobrancasView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasView.vue?vue&type=script&lang=js"

import "./ControleCobrancasView.vue?vue&type=style&index=0&id=4680055a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4680055a"]])

export default __exports__